import { actionCreator } from '@ardoq/rxbeach';
import { ViewIds } from '@ardoq/api-types';

type SetIsViewExportingPayload = {
  isExporting: boolean;
};
export const setIsViewExporting = actionCreator<SetIsViewExportingPayload>(
  '[export] SET_IS_VIEW_EXPORTING'
);

export const viewExportSucceeded = actionCreator<ViewIds>(
  '[export] VIEW_EXPORT_SUCCEEDED'
);

export const viewExportRequested = actionCreator(
  '[export] VIEW_EXPORT_REQUESTED'
);

export const viewReadyForExport = actionCreator(
  '[export] VIEW_READY_FOR_EXPORT'
);
